// extracted by mini-css-extract-plugin
module.exports = {"mobileNav":"470px","landingBlock":"landingBlock_landingBlock__8xQV1","withPadding":"landingBlock_withPadding__1ai2t"};